import { LoadableLazy } from '@confluence/loadable';

export const LazyConfluenceSmartCreationModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfluenceSmartCreationModal" */ './ConfluenceSmartCreationModal.tsx'
			)
		).ConfluenceSmartCreationModal,
});
